export const CUSTOM_URL_FINGERPRINT_HEADER = 'Custom-Url-Fingerprint';
